import { dashboard } from 'types';

export type DimensionDisplayType = 'string' | 'time' | 'date' | 'marketplace';
export interface Dimension {
  /**
   * User friendly display name
   */
  name: string;
  /**
   * Indicates how dimension value should be formatted for display.
   * All dimension values are returned as strings.
   */
  type: DimensionDisplayType;
  /**
   * Identifier used to retrieve data
   */
  dimension: dashboard.ReportQuery.Dimension;
  /**
   * Value to display if a dimension is null/empty
   */
  emptyValue?: string;
}

interface DimensionOptions {
  type: DimensionDisplayType;
  emptyValue: string;
}

export const dimension = (
  name: string,
  dimension: dashboard.ReportQuery.Dimension,
  { type = 'string', ...options }: Partial<DimensionOptions> = {}
): Dimension => ({ name, dimension, type, ...options });
